import { MemberType, ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { LumberSchema } from './LumberSchema';

export const recognizedMemberTypes: readonly MemberType[] = [
  'TopChord',
  'BottomChord',
  'Web',
  'EndVertical',
  'Slider',
  'Wedge',
  'BearingBlock',
  'GableStud',
  'RibbonBlock',
  'NonstructuralBlock',
];

export const recognizedBraceTypes: readonly MemberType[] = ['Scab', 'ExtraplanarBrace'];

const makeSchema = (type: 'brace' | 'member') =>
  new GenericModelSchema(type, {
    category: ModelCategory.ComponentDesignData,

    children: {
      lumber: LumberSchema,
    },

    properties: {},
  });

export const MemberSchema = makeSchema('member');
export const BraceSchema = makeSchema('brace');
